// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__20TMk","right":"styles_right__FK0Tz"};